import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useSelector } from 'react-redux';
import { mapFieldValues, onClickRow } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import { useEffect } from 'react';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';
import useFilteredData from '../../template/tableV2/FilterFunction';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const CustomersHome = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableCustomers.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([]);
      setTitle(`חיפוש כללי`);
    } else {
      setBreadcrumbs([]);
      setTitle(`לקוחות`);
    }
  }, [location.pathname]);

  const mappedData = mapFieldValues(context?.contextCustomers, optionsFields);

  // שימוש בפונקציה החיצונית לסינון הנתונים
  const filteredData = useFilteredData(mappedData, searchText);

  const handleRowClick = (row) => {
    if (location.pathname.endsWith('globalSearch')) {
      navigate('/plot'); // משנה את הניווט לנתיב '/block'
    }

    // לאחר מכן מפעיל את הפונקציה onClickRow עם הניווט המקורי
    // onClickRow(row, () => {}, navigate);
    navigate('/customerUpdate', { state: { value: row[0] } });
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCustomers = localTempData.find((item) => item.name === 'dataCustomers');
        if (dataCustomers) {
          setLoading(false);
        }
      }
      // fetchDataServer(['customers'], token);
      fetchDataServer(['areaGraves', 'graves'], token);
      await fetchDataServer(['customers'], token, (tableName) => {
        console.log(`Partial update for table: ${tableName}`);
      });
    }
    loadTableData();
  }, []);

  return (
    <>
      {loading && <p>Loading...</p>}
      <PaymentsManagementExample columns={columns.filter((prop) => prop.show)} defaultRows={filteredData} searchText={filteredData} onRowSelect={handleRowClick} defaultHeight={'600px'} />
      <p>
        Location: <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>/CustomersHome</span>
      </p>
    </>
  );
};

export default CustomersHome;
